import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { DESIRE_IMAGE } from './salesData';

/**
 * OPORTUNIDAD. Primera pausa de deseo después del hero: una sola fotografía
 * de abundancia a ancho completo con una afirmación corta encima.
 */
export function DesireSection() {
  return <section className="overflow-hidden bg-ivory" aria-labelledby="desire-title" data-id="element-105" data-mp="vyq98m1x0u3u">
      <div className="relative" data-id="element-106" data-mp="100bfvpnuwc5l">
        <img src={DESIRE_IMAGE} alt="Mesada cubierta de cookies gruesas de distintas variedades, algunas partidas mostrando su relleno." loading="lazy" decoding="async" className="h-[54vh] max-h-[500px] w-full object-cover sm:h-[62vh] sm:max-h-[600px]" data-id="element-107" data-mp="zza4fk2xhnnc" />
        {/* Sin oscurecimiento general: solo un degradado localizado detrás
            del texto, para que la fotografía se vea luminosa y apetecible. */}
        <div className="scrim-text absolute inset-x-0 bottom-0 h-[46%]" aria-hidden data-id="element-108" data-mp="3gp76173amf4c" />

        <div className="absolute inset-0 flex items-end" data-id="element-109" data-mp="3dxcin5ndz8ow">
          <div className="mx-auto w-full max-w-6xl px-5 pb-8 sm:px-8 sm:pb-14" data-id="element-110" data-mp="3dyxdkwdm4tna">
            <motion.div initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="max-w-2xl" data-id="element-111" data-mp="394t8kinwqvou">
              <SectionTag tone="dark" data-id="element-112" data-mp="psskn1xzdhh">La cookie que se vende sola</SectionTag>
              <h2 id="desire-title" className="mt-4 font-display text-[2rem] leading-[1.04] text-white sm:text-[3.1rem]" data-id="element-113" data-mp="3rxng4rj7blj1">
                Gruesa, alta, rellena y partida al medio
              </h2>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}